import { IRndProjectSearchParams, TRndProjectFormData } from 'src/@types';
import { IRndProject } from 'src/@types/apiResponseTypes';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/v1/rnd-project';

/**
 * R&D 프로젝트 목록 조회
 * @param params 검색 조건
 */
export const getRndProjects = async (params?: IRndProjectSearchParams) => {
  try {
    const url = SUB_URL;
    const response = await instance.get<TApiResponseData<IRndProject[]>>(url, {
      params,
    });

    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * R&D 프로젝트 단건 조회
 * @param rndProjectSid R&D 프로젝트 고유번호
 */
export const findRndProject = async (rndProjectSid: number) => {
  try {
    const url = `${SUB_URL}/${rndProjectSid}`;
    const response = await instance.get<TApiResponseData<IRndProject>>(url);

    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * R&D 프로젝트 등록
 * @param rndProjectInfo R&D 프로젝트 등록 정보
 */
export const createRndProject = async (rndProjectInfo: TRndProjectFormData) => {
  try {
    const url = SUB_URL;
    const response = await instance.post<TApiResponseData<IRndProject>>(url, rndProjectInfo);

    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
    throw new Error(
      response.data.resultCode === 'F' && response.data.errorMessage
        ? response.data.errorMessage
        : 'R&D 프로젝트 정보 등록에 실패했습니다.',
    );
  } catch (error) {
    return { success: false, errorMessage: error.message };
  }
};

/**
 * R&D 프로젝트 정보 수정
 * @param rndProjectSid R&D 프로젝트 고유번호
 * @param rndProjectInfo R&D 프로젝트 수정 정보
 */
export const updateRndProject = async (
  rndProjectSid: number,
  rndProjectInfo: TRndProjectFormData,
) => {
  try {
    const url = `${SUB_URL}/${rndProjectSid}`;
    const response = await instance.put<TApiResponseData<IRndProject>>(url, rndProjectInfo);

    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    throw new Error(
      response.data.resultCode === 'F' && response.data.errorMessage
        ? response.data.errorMessage
        : 'R&D 프로젝트 정보 수정에 실패했습니다.',
    );
  } catch (error) {
    return {
      success: false,
      errorMessage: error.message,
    };
  }
};

/**
 * R&D 프로젝트 삭제 (soft delete)
 * @param rndProjectSid R&D 프로젝트 고유번호
 */
export const deleteRndProject = async (rndProjectSid: number) => {
  try {
    const url = `${SUB_URL}/${rndProjectSid}`;
    const response = await instance.delete<TApiResponseData<boolean>>(url);

    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
